export default {
	section_main_banner: {
		title: {
			one: '힘을 실어주는',
			two: '당신의',
			three: '거래',
			four: '를',
			five: '암호화',
			six: '자산으로',
		},
		description: {
			one: '당사 플랫폼에서는 결제를 즉시 원활하게 수행할 수 있습니다,',
			two: '암호화 자산을 교환할 필요 없이',
			three: '속도, 보안, 편의성을',
			four: '보장합니다.',
		},
		cta_buttons: {
			one: '가입 시작하기',
		},
	},
	section_safety_speed: {
		cards: {
			one: {
				title: '안전성과 속도를 동시에',
				description: {
					one: '블록체인 기술의 입증된 안정성과',
					two: 'JP WORLD PAY의 독특한 플랫폼의',
					three: '혁신을 결합한',
					four: '가장 빠르고 신뢰할 수 있는 결제 시스템을 경험하고,',
					five: '전례 없는 속도, 보안, 원활한 거래를 제공합니다.',
				},
			},
			two: {
				title: '무료 등록',
				description: {
					one: '이메일 주소와 비즈니스에 대한',
					two: '기본 정보만 있으면 됩니다.',
				},
			},
			three: {
				title: '결제 시작',
				description: {
					one: '이메일을 확인하고, 회사명을 입력하고,',
					two: '계정을 연결하면',
					three: '판매 준비가 완료됩니다.',
				},
			},
		},
		title: 'JP WORLD PAY의 안전성과 속도',
		cta_button: '가입 시작하기',
	},
	section_use: {
		title: 'JP WORLD PAY는 누구나 쉽게 사용할 수 있습니다',
		cards: {
			one: {
				title: '안전한 결제',
				description:
					'JP WORLD PAY는 QR 코드 거래 중 귀하의 개인정보를 공개하지 않습니다.',
			},
			two: {
				title: '모든 회사',
				description:
					'참여하는 오프라인 가맹점에서 24시간 언제 어디서나 즉시 안전한 결제를 할 수 있습니다.',
			},
			three: {
				title: '터치 프리',
				description:
					'현금이나 신용카드를 걱정하지 마세요. 앱을 열고 결제하기만 하면 됩니다.',
			},
		},
	},
	section_free: {
		title_point: '어디서나 쇼핑 즐기기',
		title: '무료로 제공해드립니다',
		title_description: {
			one: 'JP WORLD PAY',
			two: '는 최고의 기술, 최고의 서비스,',
			three:
				'최고의 플랫폼을 완전히 무료로 제공합니다. 프리미엄 가격 없이 프리미엄 기능을 경험하세요.',
			four: '초기 비용 없이 비즈니스 성장을 시작하세요. 원활하고 안전한 결제의 미래에 오늘 참여하세요.',
		},
		cards: {
			one: {
				title: '이상적인 암호 지갑',
				description: {
					one: 'JP WORLD PAY에서 원하는',
					two: '암호화폐 지갑을 만드세요.',
				},
			},
			two: {
				title: '더 스마트하게 쇼핑',
				description: {
					one: '쇼핑할 때',
					two: 'JP WORLD PAY를 선택하세요.',
				},
			},
			three: {
				title: '저희와 함께 결제',
				description: {
					one: 'JP WORLD PAY에서 원하는',
					two: '암호화폐로 결제하세요.',
				},
			},
		},
		button: '무료 계정 만들기',
	},
	section_world: {
		title_point: '가장 빠른 결제 시스템',
		title: {
			one: '세계 어디서나',
			two: '사용할 수 있습니다',
		},
		title_description: {
			one: 'JP WORLD PAY는 신용카드 없는 원활하고 유연한 결제 경험을 제공합니다.',
			two: '온라인이든 매장 내든, Wi-Fi 연결만 있으면',
			three:
				'간단한 QR 코드로 즉시 결제할 수 있습니다. JP WORLD PAY는 키오스크와',
			four: 'POS 기계를 통한 오프라인 결제도 지원하여',
			five: '언제 어디서나 거래를 완료할 수 있습니다 - 카드 없이, 번거로움 없이, 빠르고 안전한 결제만.',
		},
		button: '무료로 시작하기',
	},
	section_member: {
		title_point: '어디서나 쇼핑 즐기기',
		title: '비즈니스 회원 무료',
		title_description: {
			one: 'One Tether는 신용카드 없이 작동합니다.',
			two: 'Wi-Fi에 연결하기만 하면 QR 코드를 통해 즉시 결제 가능 - ',
			three: '키오스크와 POS 기계를 통한 오프라인에서도.',
		},
		button: '비즈니스 스토어 열기',
	},
};
